import { userApi } from '@/axios.config';
import { basic } from '@/lib/dates';

export const state = {
  data: [],
  loading: false,
};

export const actions = {
  /**
   * Get user information
   * @returns {Promise}
   */
  async fetchClients({ commit, rootState }) {
    const user_id = rootState.userId;
    const url = `clients/${user_id}`;

    commit('updatingClients');
    try {
      const res = await userApi.get(url);
      const massagedData = res.data.map(item => ({
        ...item,
        create_time: basic(item.create_time),
      }));
      commit('updateClients', massagedData);
    } catch (e) {
      console.log(e);
      commit('updateClients');
    }
  },

  /**
   * Generate client
   * @returns {Promise}
   */
  async generateClient({ rootState }, name) {
    const user_id = rootState.userId;
    const url = `client/${user_id}`;

    try {
      const res = await userApi.post(url, { name: name });
      return {
        clientId: res.data.client_id,
        clientSecret: res.data.client_secret,
      };
    } catch (e) {
      console.log(e);
      return '';
    }
  },

  /**
   * Delete project
   * @returns {Promise}
   */
  async deleteClient({ rootState }, clientID) {
    const user_id = rootState.userId;
    const url = `client/${user_id}/${clientID}`;
    try {
      await userApi.delete(url);
    } catch (e) {
      console.log(e);
    }
  },
};

export const mutations = {
  updatingClients(state) {
    state.loading = true;
  },
  updateClients(state, data) {
    state.data = data || [];
    state.loading = false;
  },
};
